import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Circle, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const SUBJECT_STYLE = {
  "Matematik": { bg: "bg-blue-500", soft: "bg-blue-50", text: "text-blue-700", emoji: "🔢" },
  "Türkçe": { bg: "bg-rose-500", soft: "bg-rose-50", text: "text-rose-700", emoji: "📖" },
  "Fen Bilimleri": { bg: "bg-emerald-500", soft: "bg-emerald-50", text: "text-emerald-700", emoji: "🔬" },
  "Sosyal Bilgiler": { bg: "bg-amber-500", soft: "bg-amber-50", text: "text-amber-700", emoji: "🌍" },
  "İngilizce": { bg: "bg-purple-500", soft: "bg-purple-50", text: "text-purple-700", emoji: "🇬🇧" },
};

export default function Topics() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/topics").then(({ data }) => {
      setTopics(data);
      setActive(data[0]?.subject || null);
    });
  }, []);

  const subjects = [...new Set(topics.map((t) => t.subject))];
  const filtered = topics.filter((t) => t.subject === active);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">📚 Konu Anlatımı</h1>
        <p className="text-slate-500 mt-1">Bir ders ve konu seç, Nokta Öğretmen sana anlatsın!</p>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2">
        {subjects.map((s) => {
          const st = SUBJECT_STYLE[s] || {};
          return (
            <button key={s} data-testid={`subject-${s}`} onClick={() => setActive(s)}
              className={`whitespace-nowrap px-4 py-2.5 rounded-2xl text-sm font-bold border-2 transition ${active === s ? `${st.bg} text-white border-transparent` : "bg-white text-slate-600 border-slate-200"}`}>
              {st.emoji} {s}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((t, i) => {
          const st = SUBJECT_STYLE[t.subject] || {};
          return (
            <button key={t.id} data-testid={`topic-card-${t.id}`} onClick={() => navigate(`/konular/${t.id}`)}
              className="text-left bg-white border border-slate-200 rounded-2xl p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all animate-float-up"
              style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-start justify-between">
                <div className={`${st.soft} ${st.text} text-2xl w-11 h-11 rounded-xl flex items-center justify-center`}>{st.emoji}</div>
                {t.completed ? <CheckCircle2 className="w-5 h-5 text-emerald-500" /> : user?.is_subscribed ? <Circle className="w-5 h-5 text-slate-300" /> : <Lock className="w-4 h-4 text-slate-300" />}
              </div>
              <h3 className="mt-3 font-bold text-slate-900">{t.title}</h3>
              <p className="text-xs text-slate-500 mt-1">{t.subject}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
